export const getHhmByPersonId = (personId, hhms) => {

    const filteredHhms = hhms.filter(hhm => hhm.personId === personId);

    switch(true) {
        case filteredHhms.length > 1:
            throw new Error(`There are 2 or more household members in household with the same personId: ${personId}`);
        case filteredHhms.length === 0:
            console.log(`Household member not found with the personId:b${personId}`); break;
        default:
            return filteredHhms[0];

    }
};